module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          return _vm.sortBy(key)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm._f("capitalize")(key)) + "\n                  "), _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
    })])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.lastcomplete))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.due))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.timeleft))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-default",
      attrs: {
        "to": '/stanadmin/organization/' + entry.id
      }
    }, [_vm._v("More")])], 1)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-603a2795","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/AlertsNotifications/NotificationsTable.vue
// module id = 633
// module chunks = 1